import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { ApplyComponent } from './components/apply/apply.component';
import { AssignLeaveComponent } from './components/assign-leave/assign-leave.component';
import { LeavePeriodComponent } from './components/leave-period/leave-period.component';
import { MyLeaveComponent } from './components/my-leave/my-leave.component';
import { AddEntitlementComponent } from './components/add-entitlement/add-entitlement.component';
import { WorkWeekComponent } from './components/work-week/work-week.component';
import {LeaveListComponent} from './components/leave-list/leave-list.component';
import {EmployeeEntitlementsComponent} from './components/employee-entitlements/employee-entitlements.component';
import { HolidaysComponent } from './components/holidays/holidays.component';
import {MyEntitlementsComponent} from './components/my-entitlements/my-entitlements.component';
import {LeaveTypesComponent} from './components/leave-types/leave-types.component';
import { AddHolidayComponent } from './components/add-holiday/add-holiday.component';
import {AddLeaveTypeComponent} from './components/add-leave-type/add-leave-type.component';
import {LeaveBalanceComponent} from './components/leave-balance-details/leave-balance.component';

import { LeaveComponent } from './leave.component';
import { AuthGuardService } from '../../shared/services/auth-guard.service';

// Route Configuration
export const leaveRoutes: Routes = [
    {
        path: 'leave',
        component: LeaveComponent,
        children: [
            {
                path: 'apply',
                component: ApplyComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'assign-leave',
                component: AssignLeaveComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'leave-period',
                component: LeavePeriodComponent,
                canActivate: [AuthGuardService]
            },
            {
                path:'myleave',
                component:MyLeaveComponent,
                canActivate:[AuthGuardService]
            },
            {
                path:'addentitlement',
                component:AddEntitlementComponent,
                canActivate:[AuthGuardService]
            },
            {
                path:'workweek',
                component:WorkWeekComponent,
                canActivate:[AuthGuardService]
            },
            {
                path: 'leavelist',
                component: LeaveListComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'employeeentitlements',
                component: EmployeeEntitlementsComponent,
                canActivate: [AuthGuardService]
            },
            {
                path:'holodays',
                component:HolidaysComponent,
                canActivate:[AuthGuardService]
            },
            {
                path: 'myentitlements',
                component: EmployeeEntitlementsComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'leave-types',
                component: LeaveTypesComponent,
                canActivate: [AuthGuardService]
            },
            {
                path:'add-holiday',
                component:AddHolidayComponent,
                canActivate:[AuthGuardService]
            },
            {
                path: 'add-leave-type',
                component: AddLeaveTypeComponent,
                canActivate:[AuthGuardService]
            },
            {
                path: 'leave-balance',
                component: LeaveBalanceComponent,
                canActivate: [AuthGuardService]
            }
        ]
    }
];

export const leaveRoutingProviders: any[] = [
    AuthGuardService
];


// WEBPACK FOOTER //
// ./src/app/modules/leave/leave.routes.ts